import api from "@/libs/axios";
import * as ep from "./endpoints";

export default {
  namespaced: true,
  state: () => ({
    ngo_list: {
      data: [],
      pagination: {},
    },
    loading: false,
  }),
  getters: {
    ngo_list(state) {
      return state.ngo_list;
    },
    loading(state) {
      return state.loading;
    },
  },

  mutations: {
    setNgoList(state, payload) {
      state.ngo_list = payload;
    },
  },
  actions: {
    async getNgoList(context, payload) {
      context.state.loading = true;
      await api
        .post(ep.ngo_list, payload)
        .then((res) => {
          context.commit("setNgoList", res.data);
          context.state.loading = false;
        })
        .catch((err) => {});
    },
  },
};
